module.exports = __webpack_public_path__ + "img/header-1680.66d9ab5.png";